import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import Button from '../../../button/Button';
import Divider from '../../../divider/Divider';
import { useTheme } from '../../../theme-context';

interface IGeneralAdmissionManageSeatsLine {
    disableAddSeatsButton?: boolean;
    handleAddSeats: () => void;
    handleManageHolds: () => void;
    info: {
        hasHolds?: boolean;
        quantityHeldLabel: string | GenericLazyString;
    };
}

const GeneralAdmissionManageSeatsLine = ({
    disableAddSeatsButton,
    handleAddSeats,
    handleManageHolds,
    info,
}: IGeneralAdmissionManageSeatsLine): React.ReactElement => {
    const { hasHolds, quantityHeldLabel } = info;
    const { getFont, styles } = useTheme();
    const manageHoldsLink = hasHolds ? (
        <div data-testid="manage-holds-line">
            <a
                href="blank"
                className={css({
                    fontFamily: getFont('desktop/body/medium/bold').fontFamily,
                    fontWeight: getFont('desktop/body/medium/bold').fontWeight,
                    fontSize: getFont('desktop/body/medium/bold').fontSize,
                    marginBottom: '4px',
                })}
                onClick={(e) => {
                    e.preventDefault();
                    handleManageHolds();
                }}
                data-testid="manage-holds-link"
            >
                {gettext('Manage holds')}
            </a>
            <p
                className={css({
                    fontFamily: getFont('desktop/body/small').fontFamily,
                    fontWeight: getFont('desktop/body/small').fontWeight,
                    fontSize: getFont('desktop/body/small').fontSize,
                    color: styles.colors['grey-05'].color,
                })}
                data-testid="quantity-held"
            >
                {quantityHeldLabel}
            </p>
        </div>
    ) : undefined;

    return (
        <div>
            <Divider />

            <div
                className={css({
                    display: 'grid',
                    gridTemplateColumns: 'auto fit-content(100%)',
                    alignContent: 'space-between',
                    alignItems: 'center',
                    padding: '16px',
                    margin: '1px',
                })}
            >
                {manageHoldsLink}
                <div
                    className={css({
                        float: 'left',
                        justifySelf: 'self-end',
                        fontFamily: getFont('desktop/body/medium').fontFamily,
                        fontWeight: getFont('desktop/body/medium').fontWeight,
                        fontSize: getFont('desktop/body/medium').fontSize,
                    })}
                    data-testid="add-seats-line"
                >
                    <Button
                        onClick={() => {
                            handleAddSeats();
                        }}
                        disabled={disableAddSeatsButton}
                        style={!disableAddSeatsButton ? 'fill' : null}
                    >
                        {gettext('Add seats')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default GeneralAdmissionManageSeatsLine;
